import {
  FilterChip,
  FilterOption,
  Flex,
  FlexCenter,
} from '@elementary/common-ui/components';
import { compareArraysValues } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type Props = {
  type: 'incidentFilters' | 'assetFilters';
  filterOptions: FilterOption[];
};

const RuleFilterChips = ({ type, filterOptions }: Props) => {
  const methods = useFormContext();

  const filters = methods.watch(type) || [];

  const handleDelete = (index: number) => {
    const newFilters = [...filters];
    newFilters.splice(index, 1);
    methods.setValue(type, newFilters, { shouldValidate: true });
  };

  const handleSubmit = (val: any) => {
    let newFilters = methods.getValues(type) || [];

    if (val.value.length) {
      newFilters = newFilters.map((f: any) => {
        if (f.property === val.property && f.operator === val.operator) {
          if (compareArraysValues(val.prevValue, f.values)) {
            return { ...f, values: val.value };
          }
        }
        return f;
      });
    } else {
      newFilters = newFilters.filter(
        (f: any) =>
          !(f.property === val.property && f.operator === val.operator),
      );
    }

    methods.setValue(type, newFilters, { shouldValidate: true });
  };

  return (
    <Flex gap={1} sx={{ flexWrap: 'wrap' }}>
      {filters.map((filter: any, index: number) => (
        <FlexCenter key={index} sx={{ gap: 1 }}>
          {index !== 0 && (
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'common.gray2',
              }}
            >
              AND
            </Typography>
          )}
          <FilterChip
            property={filter.property}
            relationship={filter.operator}
            value={filter.values}
            onDeleteClick={() => handleDelete(index)}
            filterOptions={filterOptions}
            onSubmit={handleSubmit}
          />
        </FlexCenter>
      ))}
    </Flex>
  );
};

export default RuleFilterChips;
